<template>
	<div class="offer-name">
		<v-layout row>
			<h1>Oferta ({{value}})</h1>
			<v-icon
				v-if="!readonly"
				small
				@click="renameOpen = true"
			>edit
			</v-icon>
			<egranty-input-field-popup
				class="no-print"
				:is-open.sync="renameOpen"
				:default-value="value"
				field-type="LONG_TEXT"
				long
				label="Nowy tytuł"
				for="offer-name-new-name"
				id="offer-name-new-name"
				title="Zmień tytuł oferty"
				@save="rename"
			></egranty-input-field-popup>
		</v-layout>
		<br>
	</div>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "OfferName",
		components: {EgrantyInputFieldPopup},
		methods: {

			rename(val) {
				if (val === "" || val === undefined || val === null) {
					return;
				}
				this.$emit("input", val);
				this.renameOpen = false;
			},

		},

		data() {
			return {
				renameOpen: false,
			};
		},

		props: {
			readonly: {
				default: false,
			},
			value: {},
		},
	};
</script>

<style scoped>
	.offer-name h1 {
		margin-left: 20px;
  }
</style>
